import { render } from "./TravelPassPaymentDetails.vue?vue&type=template&id=a4a50448&lang=pug"
import script from "./TravelPassPaymentDetails.vue?vue&type=script&lang=ts"
export * from "./TravelPassPaymentDetails.vue?vue&type=script&lang=ts"
script.render = render

export default script